import React from 'react'
import userImg from '../../assets/user-img.svg'
import { t } from 'i18next';

const VisitInfoCard = ({ visit, onClickEdit }) => {
    return (
        <div className='white-bg w-100 pt-3 pb-3 rounded-3 shadow'>
            <div className='ps-4 pe-4'>
                <div className="d-flex align-items-start justify-content-between">
                    <div className='d-flex align-items-center gap-2'>
                        <img src={userImg} alt="" />
                        <div>
                            <h6 className='blue-text m-0'>{visit.full_name}</h6>
                            <span className='blue-dark-text-low-size'>{`DNI: ${visit.document}`}</span>
                        </div>
                    </div>
                    <h6
                        className='badge mt-2 pe-4 ps-4'
                        style={{ background: '#8381FF' }}
                    >
                        {t('VISIT')}
                    </h6>
                </div>
                {
                    onClickEdit ?
                        <div className='d-flex justify-content-end'>
                            {
                                onClickEdit ?
                                    <p
                                        type='button'
                                        onClick={onClickEdit}
                                        className='m-0 blue-text-tiny'
                                    >
                                        {t('EDIT')}
                                    </p>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
            </div>
        </div>

    )
}

export default VisitInfoCard